<template>
    <BasePopUpDialog v-model="value" :maxBodyWidth="690" :maxBodyHeight="450" icon="event_note" :title="baseItem.title">
         
        <div slot="dialogBody">
             <div class="preview-content" v-html="content"></div>
        </div>
        <div slot="dialogFooter">
            <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            text
                            @click="onCloseDlg">
                            Close
                        </v-btn>
            </v-card-actions>
        </div>
    </BasePopUpDialog>
</template>

<script>
    import BasePopUpDialog from "@/dialogs/base-popup-dialog.vue";
    export default {
        name: "communication-more-dialog",
        props: ["value", "item"],
        components:{BasePopUpDialog},
        data() {
            return {}
        },
        computed: {
            baseItem() {
                return this.isObject(this.item ) !== null ? this.item : null;
            },
            content(){
                return (this.item && this.item.body)?this.replaceTableClass(this.item.body):"";
            }
        },
        methods: {
            isObject(o) {
                return o !== null && typeof o === 'object' && Array.isArray(o) === false;
            },
            onCloseDlg() {
                this.$store.dispatch("closeCommunicationDialog");
            },
            replaceTableClass(body){
                return body.replace(/<table /g,"<table class='preview-content-table'")
                       .replace(/<th /g,"<th class='preview-content-table-border'")
                       .replace(/<tr /g,"<tr class='preview-content-table-border'")
                       .replace(/<td /g,"<td class='preview-content-table-border'") ;
            }
        }
    }
</script>

<style lang="scss">

    .preview-content {
        font-size: 18px;
        padding: 16px;
    }
    .preview-content-table{
        border: 1px solid grey; 
        border-collapse: collapse;
    }

     .preview-content-table-border{
        border: 1px solid grey; 
    }

</style>